/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_SubtitleInputs */

const en_colleague_subtitle = /** @type {(inputs: Colleague_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open tickets of other field engineers at your company`)
};

const ja_colleague_subtitle = /** @type {(inputs: Colleague_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自社の他のフィールドエンジニアの未完了チケット`)
};

const fr_colleague_subtitle = /** @type {(inputs: Colleague_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets ouverts des autres techniciens de votre société`)
};

const de_colleague_subtitle = /** @type {(inputs: Colleague_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offene Tickets anderer Techniker in Ihrem Unternehmen`)
};

/**
* | output |
* | --- |
* | "Open tickets of other field engineers at your company" |
*
* @param {Colleague_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_subtitle = /** @type {((inputs?: Colleague_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_subtitle(inputs)
	if (locale === "ja") return ja_colleague_subtitle(inputs)
	if (locale === "fr") return fr_colleague_subtitle(inputs)
	return de_colleague_subtitle(inputs)
});